/* eslint-disable @next/next/no-page-custom-font */
import React from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import Header24 from '../../organisms/Header24';
import Home24Services from '../../molecules/Home24Services';
import Footer24 from '../../organisms/Footer24';
import ModalWhatsApp from '../../organisms/ModalWhatsApp';
import Home24Hero from '../../molecules/Home24Hero/Home24Hero';
import Home24Carousel from '@/components/molecules/Home24Carousel';
import Home24ConhecerFinanciamento from '@/components/molecules/Home24ConhecerFinanciamento';
import Home24C2C from '@/components/molecules/Home24C2C';
import Home24ConteComSantander from '@/components/molecules/Home24ConteComSantander';
import Home24Blog from '@/components/molecules/Home24Blog';
import Home24Parceiros from '@/components/molecules/Home24Parceiros';
import Home24Canais from '@/components/molecules/Home24Canais';
import Home24HeroSimulacao from '@/components/molecules/Home24HeroSimulacao';
import Styles from './Home24.css';
import Home24Carouselv2 from '@/components/molecules/Home24Carouselv2';
import Home24HeroCPAuto from '@/components/molecules/Home24HeroCPAuto';
import Home24HeroMesAmbienteHTML from '@/components/molecules/Home24HeroMesAmbienteHTML';
import Home24HeroMegaFeiraoJul26 from '@/components/molecules/Home24HeroMegaFeiraoJul26';
import Home24HeroAgo26 from '@/components/molecules/Home24HeroAgo26';

const HomeCarouselRemake = dynamic(() => import('../../molecules/HomeCarouselRemake'), {
  ssr: false,
});

function Home() {
  return (
    <>
      <Head>
        <meta name="robots" content="index, follow" />
        <title>Faça sua simulação | Santander financiamentos</title>
        <meta
          name="Description"
          content="Santander Financiamentos: realize seu sonho! Simule online seu financiamento de carros, motos e até energia solar. Conheça crédito auto e portabilidade."
        />
        <meta
          name="keywords"
          content="simular financiamento, Financiamento de veículos, Simular financiamento Santander, Simulação financiamento, refinanciamento de veículo, Meu financiamento, Santander financiamento de veículos, financiamento de carros, Financiamentos, Financiamento energia solar, Meu financiamento Santander, Financiamento de motos, Financiar veículo, crédito auto, portabilidade financiamento veículo, financiamento para PCD, financiamento para motorista de aplicativo, Imposto de renda financiamento, saldo devedor financiamento, financiamento de veículo online, portabilidade financiamento veículo Santander, saldo devedor financiamento Santander, transferir financiamento de veículo, santander financiamento, financiamento carro, meu financiamento santander"
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Faça sua simulação | Santander financiamentos" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Conheça as nossas opções para financiar seu veículo com segurança e agilidade na Santander Financiamentos. Simule agora e encontre a solução ideal!"
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/home24/c2c-vender.png"
        />
        <meta
          property="og:image:alt"
          content="Dois homens apertam as mãos ao lado de um carro vermelho ao realizarem a venda do veículo financiado pela Santander Financiamentos, enquanto uma mulher está sentada dentro do veículo."
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />
        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta name="twitter:title" content="Faça sua simulação | Santander financiamentos" />
        <meta
          name="twitter:description"
          content="Conheça as nossas opções para financiar seu veículo com segurança e agilidade na Santander Financiamentos. Simule agora e encontre a solução ideal!"
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/home24/c2c-vender.png"
        />
        <meta
          property="twitter:image:alt"
          content="Dois homens apertam as mãos ao lado de um carro vermelho ao realizarem a venda do veículo financiado pela Santander Financiamentos, enquanto uma mulher está sentada dentro do veículo."
        />
        <meta property="twitter:image:type" content="image/png" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />

        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Figtree:ital,wght@0,300..900;1,300..900&display=swap"
          rel="stylesheet"
        />
      </Head>

      {/* <CTAFlutuante /> */}
      <Header24 isHome isHome24 />
      {/* <Home24Hero /> */}
      {/* <Home24HeroSimulacao /> */}
      {/* <Home24HeroCPAuto /> */}
      {/* <Home24HeroMesAmbienteHTML /> */}
      {/* <Home24HeroMegaFeiraoJul26 /> */}
      <Home24HeroAgo26 />
      <Home24Services />
      <Home24Carouselv2 />
      <Home24ConhecerFinanciamento />
      <Home24C2C />
      <Home24ConteComSantander />
      <Home24Blog />
      <Home24Canais />
      <Home24Parceiros />
      <Footer24 />
      <ModalWhatsApp />
      <style jsx>{Styles}</style>
    </>
  );
}

export default Home;
